import { createContext } from 'react'
type InitValue = {
    cacheStates?: Record<string, any>;
    dispatch?: any;
    mount?: any;
    handleScroll?: any
}
const CacheContext = createContext<InitValue>({})
export default CacheContext
